import React, { useEffect, useRef, useState } from "react";
import "./first.style.scss";
import { Button, Card, ConfigProvider, Input, Select } from "antd";
import "react-modern-calendar-datepicker/lib/DatePicker.css";
import { Calendar } from "react-modern-calendar-datepicker";
import useOnBlur from "../../../../util/useOnBlue";
import { get, post, responseValidator } from "../../../../api";
import { toast } from "react-toastify";
import CompleteCover from "../completeCover/completeCover.index";
import Loading from "../../../../loading/loading.index";
import { Complete } from "../verification.index";
import { faNumToEnNum } from "../../../../util/string";
const { TextArea } = Input;
const { Option } = Select;

export default function FirstLevel(props) {
    const [selectedDay, setSelectedDay] = useState(null);
    const [birth, setBirth] = useState(null);
    const [isCalender, setIsCalender] = useState(false);
    const isCalenderRef = useRef();
    const [birthInputShow, setBirthInputShow] = useState();
    const [name, setName] = useState(null);
    const [city, setCity] = useState(null);
    const [province, setProvince] = useState(null);
    const [address, setAddress] = useState(null);
    const [lastName, setLastName] = useState(null);
    const [nationalNumber, setNationalNumber] = useState(null);
    const persian = /^[\u0600-\u06FF\s]+$/;
    const [loading, setLoading] = useState(false);
    const [isCompleteProfile, setIsCompleteProfile] = useState(false);
    const [openBank, setOpenBank] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    const [nationalCardSrc, setNationalCardSrc] = useState(null);
    const [adminMessage, setAdminMessage] = useState(null);
    const [contentType, setContentType] = useState(null);

    function convertDate() {}

    // 0:not open , 1:open , 2:closed
    function datePickerHandler(e) {
        setSelectedDay(e);
        console.log(e);
        setBirthInputShow(e.year + "/" + e.month + "/" + e.day);

        const JalaliDate = {
            g_days_in_month: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
            j_days_in_month: [31, 31, 31, 31, 31, 31, 30, 30, 30, 30, 30, 29]
        };

        JalaliDate.jalaliToGregorian = function(j_y, j_m, j_d) {
            j_y = parseInt(j_y);
            j_m = parseInt(j_m);
            j_d = parseInt(j_d);
            var jy = j_y - 979;
            var jm = j_m - 1;
            var jd = j_d - 1;

            var j_day_no =
                365 * jy +
                parseInt(jy / 33) * 8 +
                parseInt(((jy % 33) + 3) / 4);
            for (var i = 0; i < jm; ++i)
                j_day_no += JalaliDate.j_days_in_month[i];

            j_day_no += jd;

            var g_day_no = j_day_no + 79;

            var gy =
                1600 +
                400 *
                    parseInt(
                        g_day_no / 146097
                    ); /* 146097 = 365*400 + 400/4 - 400/100 + 400/400 */
            g_day_no = g_day_no % 146097;

            var leap = true;
            if (g_day_no >= 36525) {
                /* 36525 = 365*100 + 100/4 */
                g_day_no--;
                gy +=
                    100 *
                    parseInt(
                        g_day_no / 36524
                    ); /* 36524 = 365*100 + 100/4 - 100/100 */
                g_day_no = g_day_no % 36524;

                if (g_day_no >= 365) g_day_no++;
                else leap = false;
            }

            gy += 4 * parseInt(g_day_no / 1461); /* 1461 = 365*4 + 4/4 */
            g_day_no %= 1461;

            if (g_day_no >= 366) {
                leap = false;

                g_day_no--;
                gy += parseInt(g_day_no / 365);
                g_day_no = g_day_no % 365;
            }

            for (
                var i = 0;
                g_day_no >= JalaliDate.g_days_in_month[i] + (i == 1 && leap);
                i++
            )
                g_day_no -= JalaliDate.g_days_in_month[i] + (i == 1 && leap);
            var gm = i + 1;
            var gd = g_day_no + 1;

            gm = gm < 10 ? "0" + gm : gm;
            gd = gd < 10 ? "0" + gd : gd;

            return [gy, gm, gd];
        };

        let jD = JalaliDate.jalaliToGregorian(e.year, e.month, e.day),
            jResult = jD[0] + "/" + jD[1] + "/" + jD[2];
        // let date = moment
        console.log(jResult);
        // from(e.year + "/" + e.month + "/" + e.day, "en", "YYYY/MM/DD").format("YYYY/MM/DD")
        //console.log(date);
        // date = new Date(date);
        // console.log(date);
        // date = date.toISOString();
        //console.log(date);
        setBirth(jResult);
        setIsCalender(false);
    }

    const onCalendarChangeHandler = e => {
        var d_y = e.$jy;
        var d_m =
            parseInt(e.$jM) + 1 >= 10
                ? parseInt(e.$jM) + 1
                : "0" + (parseInt(e.$jM) + 1).toString();
        var d_d =
            parseInt(e.$jD) >= 10 ? parseInt(e.$jD) : "0" + parseInt(e.$jD);

        setBirth(d_y + "/" + d_m + "/" + d_d);
    };

    function getDetail() {
        get("/User/Auth/Level1").then(response => {
            setIsLoading(false);
            if (responseValidator(response.status) && response.data.data) {
                console.log(response.data.data);
                if (response.data.data.city) setCity(response.data.data.city);
                if (response.data.data.province)
                    setProvince(response.data.data.province);
                if (response.data.data.address)
                    setAddress(response.data.data.address);
                if (response.data.data.firstName)
                    setName(response.data.data.firstName);
                if (response.data.data.lastName)
                    setLastName(response.data.data.lastName);
                if (response.data.data.natinalCode) {
                    setNationalNumber(response.data.data.natinalCode);
                    setIsCompleteProfile(true);
                }
                if (response.data.data.birthDate)
                    setBirthInputShow(
                        new Date(
                            response.data.data.birthDate
                        ).toLocaleDateString("fa-IR")
                    );
                if (response.data.data.adminMessage) {
                    setAdminMessage(response.data.data.adminMessage);
                }
            } else {
                toast.error(response.data.message);
            }
        });
    }

    useEffect(() => {
        getDetail();
    }, []);
    useOnBlur(isCalenderRef, () => {
        if (isCalender) setIsCalender(false);
    });

    function NameHandler(e) {
        if (persian.test(e.target.value) || e.target.value === "") {
            setName(e.target.value);
        }
    }

    function AddressHandler(e) {
        if (persian.test(e.target.value) || e.target.value === "") {
            setAddress(e.target.value);
        }
    }

    function CityHandler(e) {
        if (persian.test(e.target.value) || e.target.value === "") {
            setCity(e.target.value);
        }
    }

    function ProvinceHandler(e) {
        if (persian.test(e.target.value) || e.target.value === "") {
            setProvince(e.target.value);
        }
    }

    function lastNameHandler(e) {
        if (persian.test(e.target.value) || e.target.value === "") {
            setLastName(e.target.value);
        }
    }

    function onFormSubmitHandler() {
        setLoading(true);
        setIsLoading(true);
        const body = {
            firstName: name,
            lastName: lastName,
            nationalCode: nationalNumber,
            birthdate: birth,
            address: address,
            city: city,
            province: province
        };
        post(`/User/Profile/Create`, body).then(response => {
            setLoading(false);
            setIsLoading(false);
            if (responseValidator(response.status)) {
                toast.success(response.data.message);
                getDetail();
                console.log(response);
            } else toast.error(response.data.message);
        });
    }

    /*  function finishUploadHandler(e) {
        setNationalCartStatus(1);
        console.log(e.response);
        setNationalCardSrc(e.response.data.file);
    }
*/
    if (isLoading) return <Loading />;
    return (
        <div className="tmex-verification-level1">
            <Card style={{ marginTop: "0" }}>
                {props.data.description &&
                    props.data.description
                        .split(".")
                        .map(item =>
                            item === "" ? null : <h5>{item + "."}</h5>
                        )}
            </Card>

            <Card
                className="profile"
                title={
                    isCompleteProfile ? (
                        <Complete title="مشخصات فردی" />
                    ) : (
                        "مشخصات فردی"
                    )
                }
                cover={
                    isCompleteProfile ? (
                        <div>
                            <CompleteCover text="تایید شده" />
                        </div>
                    ) : null
                }
            >
                <div className="items">
                    <Input
                        value={name}
                        onChange={NameHandler}
                        placeholder="نام به فارسی"
                    />
                    <Input
                        value={lastName}
                        onChange={lastNameHandler}
                        placeholder="نام خانوادگی به فارسی"
                    />
                </div>

                <div className="items">
                    <Input
                        value={nationalNumber}
                        onChange={e => {
                            let value = faNumToEnNum(e.target.value);
                            var char =
                                value.length !== 0
                                    ? value.split("")[
                                          value.split("").length - 1
                                      ]
                                    : value;
                            if (
                                char == "." ||
                                char == "0" ||
                                char == "1" ||
                                char == "2" ||
                                char == "3" ||
                                char == "4" ||
                                char == "5" ||
                                char == "6" ||
                                char == "7" ||
                                char == "8" ||
                                char == "9"
                            ) {
                                setNationalNumber(value);
                            }
                        }}
                        type={"text"}
                        placeholder="شماره ملی"
                    />
                    <div className="birth">
                        <Input
                            onClick={() => setIsCalender(true)}
                            value={birthInputShow}
                            readOnly={true}
                            placeholder="تاریخ تولد"
                            style={{ width: "100%" }}
                        />
                        <i
                            onClick={() => setIsCalender(!isCalender)}
                            className="icon icon-calendar"
                        />
                        <div
                            ref={isCalenderRef}
                            className={`my-calender ${
                                isCalender ? "active" : ""
                            }`}
                        >
                            <Calendar
                                colorPrimary={"#157DE1"}
                                value={selectedDay}
                                locale="fa"
                                onChange={datePickerHandler}
                                shouldHighlightWeekends
                            />
                        </div>
                    </div>
                </div>
                <div className="items">
                    <Input
                        value={province}
                        onChange={e => ProvinceHandler(e)}
                        placeholder="استان"
                    />
                    <Input
                        value={city}
                        onChange={e => CityHandler(e)}
                        placeholder="شهر"
                    />
                </div>
                <div className="items">
                    <TextArea
                        style={{ marginLeft: "0px" }}
                        value={address}
                        onChange={e => AddressHandler(e)}
                        rows={4}
                        placeholder="آدرس پستی"
                    />
                </div>

                <Button
                    disabled={
                        !name ||
                        !lastName ||
                        !birth ||
                        !nationalNumber ||
                        !address ||
                        !city ||
                        !province
                    }
                    loading={loading}
                    type={"primary"}
                    onClick={onFormSubmitHandler}
                >
                    ثبت
                </Button>
            </Card>

            {/*   <Card
                className="national-card-uploader"
                title={
                    nationalCartStatus === 0 ? (
                        "ثبت تصویر کارت ملی"
                    ) : nationalCartStatus === 1 ? (
                        <Pending req="تایید" title="ثبت تصویر کارت ملی" />
                    ) : nationalCartStatus === 2 ? (
                        <Complete title="ثبت تصویر کارت ملی" />
                    ) : (
                        <Error title="ثبت تصویر کارت ملی" />
                    )
                }
                cover={
                    nationalCartStatus === 0 ||
                    nationalCartStatus === 3 ? null : (
                        <div>
                            <CompleteCover text="ارسال شده" />
                        </div>
                    )
                }
            >
                {nationalCartStatus === 3 && (
                    <DragDrop
                        hasSample={false}
                        accept="image/*"
                        finish={e => finishUploadHandler(e)}
                        name="melliCardPhoto"
                        multiple={false}
                        url={SERVER + "/User/MelliCard"}
                        pr
                    />
                )}
                {nationalCardSrc ? (
                    <div className="nationalCard">
                        <img
                            alt="national-card-photo"
                            className="nationalCard"
                            src={
                                `data:${contentType};base64,` + nationalCardSrc
                            }
                        />
                    </div>
                ) : (
                    <DragDrop
                        accept="image/*"
                        finish={() => setNationalCartStatus(1)}
                        name="melliCardPhoto"
                        multiple={false}
                        url={SERVER + "/User/MelliCard"}
                    />
                )}

                {adminMessage && nationalCartStatus === 3 && (
                    <Alert
                        style={{ marginTop: "22px" }}
                        type="error"
                        message={`پیام مدیر :${adminMessage}`}
                        banner
                    />
                )}
            </Card>*/}
        </div>
    );
}
